import InvoiceStatsContent from "../content/invoiceStatsContent";
import Layout from "../layout/Layout";

const InvoiceStats = () => {
  return (
    <Layout>
      <InvoiceStatsContent />
    </Layout>
  );
};

export default InvoiceStats;